export const USER = "user";
export const ADMIN = "admin";
